<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-dialog fullscreen :value="value" persistent scrollable>
    <v-card color="kbLight">
      <v-toolbar class="kbPurple" dark flat max-height="64px">
        <div class="text-h6">
          {{ method === 'edit' ? $t('general.editTrigger') : $t('general.createTrigger') }}
        </div>
        <v-spacer/>
        <v-btn icon @click="toggleModal()">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-6">
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <v-card color="kbWhite">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field :label="$t('general.title')"
                                    color="kbDarkBlueText"
                                    :rules="[rules.required]"
                                    v-model="trigger.title">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field :label="$t('general.description')"
                                    color="kbDarkBlueText"
                                    :rules="[rules.required]"
                                    v-model="trigger.description">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-select v-model="trigger.onActionType"
                                color="kbDarkBlueText"
                                item-color="kbDarkBlueText"
                                :items="triggerActionTypes"
                                item-value="const"
                                item-text="text"
                                :rules="[rules.required]"
                                :label="$t('general.executeTriggerWhenActionFire')"
                                multiple
                                chips
                                deletable-chips/>
                    </v-col>

                    <v-col cols="12"
                           v-if="trigger.onActionType &&
                                 trigger.onActionType.length &&
                                 trigger.onActionType.includes('ACTION_CUSTOM')">
                      <v-text-field :label="$t('general.customActionToFilter')"
                                    color="kbDarkBlueText"
                                    :rules="[rules.required]"
                                    v-model="trigger.onCustomActionTypeName">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-select v-model="trigger.toDo"
                                color="kbDarkBlueText"
                                item-color="kbDarkBlueText"
                                item-text="text"
                                item-value="value"
                                :items="triggerToDoList"
                                :rules="[rules.required]"
                                :label="$t('general.actionsToExecute')"
                                multiple
                                chips
                                deletable-chips/>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12"
                   v-if="trigger.onActionType &&
                         Array.isArray(trigger.onActionType) &&
                         trigger.onActionType.includes('ACTION_ON_JOURNEY_SET')">
              <v-card color="kbWhite">
                <v-card-text>
                  <h3 class="hidden-sm-and-up">{{ $t('general.pickAJourneyStatus') }}</h3>
                  <h4 class="hidden-xs-only kbDarkBlueText--text">{{ $t('general.pickAJourneyStatus') }}</h4>
                  <v-autocomplete class="mt-2"
                                  color="kbDarkBlueText"
                                  item-value="id"
                                  item-text="name"
                                  :label="$t('general.journeys')"
                                  :items="journeys"
                                  :rules="[rules.required]"
                                  :search-input.sync="searchJourneys"
                                  :value="journeyId"
                                  @change="onJourneyIdChange" />
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12"
                   v-if="trigger.onActionType &&
                         Array.isArray(trigger.onActionType) &&
                         trigger.onActionType.includes('ACTION_ON_EXTRADATA_FIELD_CHANGE')">
              <v-card color="kbWhite">
                <v-card-text>
                  <h3 class="hidden-sm-and-up">{{ $t('general.pickExtraData') }}</h3>
                  <h4 class="hidden-xs-only kbDarkBlueText--text">{{ $t('general.pickExtraData') }}</h4>
                  <v-row>
                    <v-col cols="12" class="pt-0">
                      <v-select v-model="extraDataField"
                                class="mt-2"
                                color="kbDarkBlueText"
                                item-value="name"
                                item-text="name"
                                :label="$t('general.pickExtraData')"
                                :items="appCustomExtradatas"
                                :rules="[rules.required]" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12"
                   v-if="trigger.onActionType &&
                           Array.isArray(trigger.onActionType) &&
                           trigger.onActionType.includes('ACTION_ON_EXTRADATA_VALUE_CHANGE')">
              <v-card color="kbWhite">
                <v-card-text>
                  <h3 class="hidden-sm-and-up">{{ $t('general.pickExtraDataFieldAndValue') }}</h3>
                  <h4 class="hidden-xs-only kbDarkBlueText--text">{{ $t('general.pickExtraDataFieldAndValue') }}</h4>
                  <v-row>
                    <v-col cols="12" class="pt-0">
                      <v-select v-model="extraDataWithValue.field"
                                class="mt-2"
                                color="kbDarkBlueText"
                                item-value="id"
                                item-text="name"
                                :label="$t('general.pickExtraDataFieldAndValue')"
                                :items="appCustomExtradatas"
                                :rules="[rules.required]" />
                    </v-col>

                    <v-col cols="12"
                           class="pt-0">
                      <v-text-field v-model="extraDataWithValue.value"
                                    class="mt-2"
                                    color="kbDarkBlueText"
                                    :label="$t('general.writeExtraDataValue')"
                                    :rules="[rules.required]" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" v-for="(actionType, index) in trigger.toDo" :key="index">
              <v-card color="kbWhite" v-if="actionType === 'smsToUser'">
                <v-card-text>
                  <v-row class="pa-2" align="center">
                    <h3 class="hidden-sm-and-up">{{ $t('general.smsBody') }}</h3>
                    <h4 class="hidden-xs-only kbDarkBlueText--text">{{ $t('general.smsBody') }}</h4>
                  </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-text>
                  <sms-data :sms="sms"/>
                </v-card-text>
              </v-card>
              <v-card color="kbWhite" v-else-if="actionType === 'emailToUser'">
                <v-card-text>
                  <v-row class="pa-2"  align="center" >
                    <v-col cols="12">
                      <SendEmail :email="email"
                                 :was-template-saved-or-updated="wasTemplateSavedOrUpdated"
                                 @onHtmlExported="onHtmlExported"
                                 @onSaveOrUpdateTemplateStatusChange="changeSaveOrUpdateTemplateStatus()"
                                 @onSubjectChange="changeEmailSubject"
                                 @onSelectedTemplateChange="setEmailTemplateId" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <v-card color="kbWhite" v-else-if="actionType === 'postRequestToServer'">
                <v-card-text>
                  <v-row class="pa-2"  align="center" >
                    <h3 class="hidden-sm-and-up">{{ $t('general.postRequestData') }}</h3>
                    <h4 class="hidden-xs-only kbDarkBlueText--text">{{ $t('general.postRequestData') }}</h4>
                  </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-text>
                  <v-text-field v-model="request.post.url"
                                color="kbDarkBlueText"
                                class="mt-4 text-center"
                                hide-details
                                style="max-width: 600px; margin: auto"
                                label="URL"
                                outlined
                                single-line
                                clearable
                                :rules="[rules.required, rules.url]"/>
                </v-card-text>
              </v-card>
              <v-card color="kbWhite" v-else-if="actionType === 'createTaskForUser'">
                <v-card-text>
                  <v-row class="pa-2">
                    <h3 class="hidden-sm-and-up">{{ $t('general.assignTaskAfterSettingJourney') }}</h3>
                    <h4 class="hidden-xs-only kbDarkBlueText--text">{{ $t('general.assignTaskAfterSettingJourney') }}</h4>
                  </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-text>
                  <v-text-field v-model="task.name"
                                color="kbDarkBlueText"
                                class="mt-4 text-center"
                                :label="$t('general.insertANewTask')"
                                :rules="[rules.required]"/>
                  <v-textarea v-model="task.observation"
                              :label="$t('general.observations')"
                              outlined
                              color="kbDarkBlueText" />
                  <v-text-field v-model="task.after"
                                color="kbDarkBlueText"
                                :label="$t('general.timeInMinutesToCreateTaskAfterSettingJourney')"
                                :rules="[rules.required, rules.onlyNumbers]"/>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mr-2"
               color="red"
               outlined
               @click="toggleModal()">
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn color="kbPurple"
               dark
               @click="submit"
               :loading="loadingSubmit">
          {{ $t('general.saveTrigger') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { EventBus } from '@/eventBus.js'
import { mapState, mapGetters } from 'vuex'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
import SendEmail from '@/components/widgets/EmailTemplates/SendEmail'
import SmsData from '@/pages/App/Communications/Sms/SmsData.vue'

export default {
  components: { SendEmail, SmsData },
  computed: {
    ...mapGetters(['triggerActionTypes', 'triggerToDoList']),
    ...mapState({
      appCustomExtradatas: state => state.apps.appCustomExtradatas,
      journeys: state => state.journey.journeys,
      selectedTrigger: state => state.triggers.selectedTrigger
    })
  },
  created () {
    this.getJourneys()
    this.getAppExtraData()
  },
  data () {
    return {
      email: {
        subject: '',
        from: '',
        templateId: '',
        html: ''
      },
      extraDataField: '',
      extraDataWithValue: {
        field: '',
        value: ''
      },
      journeyId: '',
      loadingSubmit: false,
      loadingTrigger: false,
      request: {
        post: {
          url: ''
        }
      },
      rules,
      searchJourneys: '',
      sms: {
        message: ''
      },
      task: {
        name: '',
        observation: '',
        after: '',
        timeUnits: 'minutes'
      },
      trigger: {
        title: '',
        description: '',
        onActionType: [],
        onCustomActionTypeName: '',
        toDo: [],
        extraData: {}
      },
      wasTemplateSavedOrUpdated: false
    }
  },
  methods: {
    changeSaveOrUpdateTemplateStatus () {
      this.wasTemplateSavedOrUpdated = true
    },
    changeEmailSubject (subject) {
      this.email.subject = subject
    },
    clearTrigger () {
      this.$refs.form.reset()
      this.trigger = {
        title: '',
        description: '',
        onActionType: [],
        onCustomActionTypeName: '',
        toDo: [],
        extraData: {}
      }
      this.email = {
        subject: '',
        from: '',
        templateId: '',
        html: ''
      }
      this.extraDataField = ''
      this.extraDataWithValue = {
        field: '',
        value: ''
      }
      this.journeyId = ''
      this.request = {
        post: {
          url: ''
        }
      }
      this.searchJourneys = ''
      this.sms = {
        message: ''
      }
      this.task = {
        name: '',
        observation: '',
        after: '',
        timeUnits: 'minutes'
      }
      this.wasTemplateSavedOrUpdated = false
    },
    async createTrigger () {
      if (!this.$refs.form.validate()) return
      try {
        this.loadingSubmit = true
        this.setTriggerExtraData()
        await this.$store.dispatch('createTrigger', this.trigger)
        this.loadingSubmit = false
        notifications.success(this.$t('general.triggerSuccessfullyCreated'))
        this.getTriggers()
        this.toggleModal()
      } catch (e) {
        this.loadingSubmit = false
        notifications.error(e)
      }
    },
    async getAppExtraData () {
      try {
        await this.$store.dispatch('getAppCustomExtradatas')
      } catch (e) {
        notifications.error(e)
      }
    },
    async getJourneys () {
      await this.$store.dispatch('getJourneys', {
        companyId: this.$store.getters.companyUuid,
        appId: this.$store.getters.appUuid,
        search: this.searchJourneys
      })
    },
    async getTrigger () {
      try {
        this.loadingTrigger = true
        await this.$store.dispatch('getTrigger', this.selectedTriggerId)
        this.setLocalTrigger()
        this.loadingTrigger = false
      } catch (e) {
        this.loadingTrigger = false
        notifications.error(e)
      }
    },
    getHtmlTemplate () {
      EventBus.$emit('onExportHtml')
    },
    getTriggers () {
      this.$emit('getTriggers')
    },
    onHtmlExported (html) {
      this.email.html = html
      this.method === 'edit' ? this.updateTrigger() : this.createTrigger()
    },
    onJourneyIdChange (journeyId) {
      this.journeyId = journeyId
    },
    setEmailTemplateId (templateId) {
      this.email.templateId = templateId
    },
    setLocalTrigger () {
      this.trigger = { ...this.selectedTrigger }
      this.setTriggerVariablesBasedOnExtraData()
    },
    setTriggerExtraData () {
      this.trigger.extraData = {}
      if (this.trigger.onActionType.includes('ACTION_ON_JOURNEY_SET')) {
        this.trigger.extraData.journeyId = this.journeyId
      }
      if (this.trigger.onActionType.includes('ACTION_ON_EXTRADATA_FIELD_CHANGE')) {
        this.trigger.extraData.onExtraDataFieldChange = { field: this.extraDataField }
      }
      if (this.trigger.onActionType.includes('ACTION_ON_EXTRADATA_VALUE_CHANGE')) {
        this.trigger.extraData.onExtraDataValueChange = { ...this.extraDataWithValue }
      }
      if (this.trigger.toDo && Array.isArray(this.trigger.toDo) && this.trigger.toDo.length) {
        for (let i = 0; i < this.trigger.toDo.length; i++) {
          if (this.trigger.toDo[i] === 'emailToUser') {
            this.trigger.extraData.email = { ...this.email }
            this.trigger.extraData.email.from = this.$store.getters.selectedApp.app_name
          }
          if (this.trigger.toDo[i] === 'smsToUser') {
            this.trigger.extraData.sms = { ...this.sms }
          }
          if (this.trigger.toDo[i] === 'postRequestToServer') {
            this.trigger.extraData.request = { ...this.request }
          }
          if (this.trigger.toDo[i] === 'createTaskForUser') {
            this.trigger.extraData.task = { ...this.task }
          }
        }
      }
    },
    setTriggerVariablesBasedOnExtraData () {
      if (this.trigger &&
          this.trigger.extraData &&
          typeof this.trigger.extraData === 'object' &&
          Object.keys(this.trigger.extraData).length) {
        if (this.trigger.extraData.email) this.email = { ...this.trigger.extraData.email }
        if (this.trigger.extraData.sms) this.sms = { ...this.trigger.extraData.sms }
        if (this.trigger.extraData.request) this.request = { ...this.trigger.extraData.request }
        if (this.trigger.extraData.journeyId) this.journeyId = this.trigger.extraData.journeyId
        if (this.trigger.extraData.onExtraDataFieldChange) this.extraDataField = this.trigger.extraData.onExtraDataFieldChange.field
        if (this.trigger.extraData.onExtraDataValueChange) this.extraDataWithValue = { ...this.trigger.extraData.onExtraDataValueChange }
        if (this.trigger.extraData.task) this.task = { ...this.trigger.extraData.task }
      }
    },
    submit () {
      if (this.trigger.toDo && Array.isArray(this.trigger.toDo) && this.trigger.toDo.includes('emailToUser')) {
        this.getHtmlTemplate()
      } else {
        this.method === 'edit' ? this.updateTrigger() : this.createTrigger()
      }
    },
    toggleModal () {
      this.$emit('input', false)
      this.clearTrigger()
    },
    async updateTrigger () {
      if (!this.$refs.form.validate()) return
      try {
        this.loadingSubmit = true
        this.setTriggerExtraData()
        await this.$store.dispatch('updateTrigger', this.trigger)
        this.loadingSubmit = false
        notifications.success(this.$t('general.triggerSuccessfullyUpdated'))
        this.getTriggers()
        this.toggleModal()
      } catch (e) {
        this.loadingSubmit = false
        notifications.error(e)
      }
    }
  },
  props: {
    method: {
      type: String,
      default: 'create'
    },
    selectedTriggerId: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    searchJourneys () {
      this.getJourneys()
    },
    value (value) {
      if (value && this.method === 'edit') {
        this.getTrigger()
      }
    }
  }
}
</script>
